import { createFileRoute } from "@tanstack/react-router";
import { MslAvailabilityFormPage } from "@/features/contracts/msl-availability-form-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/msl-dostepnosc/$id")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.msl-dostepnosc",
			location.pathname,
		);
	},
	component: MslAvailabilityFormPage,
});
